import { Typography } from '@mui/material';

export default function Home() {
  return (
    <Typography variant="h3" noWrap component="div">
      Contact
    </Typography>
  );
}
